// Tonight on the floor (backend tonight.py): a table out of use, two tables joined. Both
// are a manager's, on the till, and both end at close. The set-up itself (which tables,
// where, how many seats) is the back office's now.

export const isOutOfUse = (t) => !!t?.out_of_use;
export const isJoined = (t) => !!t?.joined;
export const isJoinLead = (t) => !!t?.joined && t.joined.lead === t.id;
// Pushed up against another table: the party sits at the lead, not here.
export const joinedBehind = (t) => !!t?.joined && t.joined.lead !== t.id;
export const seatable = (t) => !isOutOfUse(t) && !joinedBehind(t);

// The floor as service sees it: a join is one table, "T5 + T6", with the seats added up,
// and the tables behind the lead aren't shown on their own. `own_name` keeps the lead's.
export function floorTables(tables) {
  const byId = new Map(tables.map((t) => [t.id, t]));
  return tables
    .filter((t) => !joinedBehind(t))
    .map((t) => {
      if (!isJoinLead(t)) return t;
      const members = (t.joined.ids || []).map((id) => byId.get(id)).filter(Boolean);
      if (members.length < 2) return t;
      return {
        ...t,
        own_name: t.name,
        name: members.map((m) => m.name).join(' + '),
        capacity: members.reduce((n, m) => n + (Number(m.capacity) || 0), 0),
      };
    });
}

// Why a server can't seat this table, said where they tapped it.
export function refusal(t, tables = []) {
  if (isOutOfUse(t)) {
    const why = t.out_of_use.reason ? ` (${t.out_of_use.reason})` : '';
    return `${t.name} is out of use tonight${why}. A manager can put it back in use.`;
  }
  if (joinedBehind(t)) {
    const lead = floorTables(tables).find((x) => x.id === t.joined.lead);
    return `${t.name} is joined tonight: seat the party at ${lead?.name || 'the table it joins'}.`;
  }
  return null;
}
